export default __webpack_public_path__ + "static/media/35.5deaca38.png";